import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, Spinner } from "react-bootstrap";
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { BsFillFileEarmarkCheckFill } from "react-icons/bs";
import CPF from "../../components/Formatters/CPF";
import appConfig from "../../config/app.config";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
import DateTime from "../../components/Formatters/DateTime";
import FileDownloader from "../../components/UI/Button/FileDownloader";

const AssinaturaVerificacao = () => {
  const params = useParams();
  const [exibirInstrucoes, setExibirInstrucoes] = useState(false);
  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (params?.ticket) {
      request(apiRoutes.usuarios.arquivo.info, null, { routeParams: params });
    }
  }, [request, params]);

  const arquivo = (data || {}).result || {};

  if (!isLoading && arquivo && !arquivo.assinado) {
    arquivo.erro = (errors || {}).message || "Arquivo inválido ou não assinado";
  }

  const arquivoNome = arquivo?.arquivoNome;

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12 col-lg-12 col-md-12">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-4 d-none d-lg-block bg-login-image" />
                <div className="col-lg-8">
                  <div className="p-4 p-lg-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900">Verificação de Assinatura Digital da SEFAZ-RN</h1>
                    </div>

                    {isLoading ? (
                      <div className="m-auto align-center text-center text-muted">
                        <Spinner animation="border" role="status" />
                        <br />
                        &nbsp;Carregando informações do arquivo...
                      </div>
                    ) : (
                      <form className="form">
                        <div className="form-group">
                          <div className="form-group row mt-5">
                            {!arquivo.assinado && arquivo.erro && (
                              <div className="col-12 mb-3">
                                <Alert variant="danger">{arquivo.erro}</Alert>
                              </div>
                            )}
                            {!arquivo.erro && (
                              <>
                                {" "}
                                <div className="col-6 mb-3">
                                  <b>Arquivo:</b>
                                  <p className="text-dark">
                                    {arquivo.arquivoNome || "-"}
                                    {arquivo.arquivo && (
                                      <FileDownloader binario={arquivo.arquivo} tooltip="Visualizar Documento" />
                                    )}
                                  </p>
                                </div>
                                <div className="col-6">
                                  <b>Hash SHA-1 do arquivo:</b>
                                  <p className="text-dark">
                                    <p className="text-dark">{arquivo.arquivoHash || "-"}</p>
                                  </p>
                                </div>
                                <div className="col-12 mb-3">
                                  <b>Descrição:</b>
                                  <p className="text-dark">{arquivo.contextoDescricao || "-"}</p>
                                </div>
                              </>
                            )}
                          </div>
                          {arquivo.assinado && (
                            <>
                              <div className="form-group row">
                                <div className="col-6">
                                  <b>Assinado por:</b>
                                  <p className="text-dark">{arquivo.assinaturaNome}</p>
                                </div>
                                <div className="col-6">
                                  <b>CPF:</b>
                                  <p className="text-dark">
                                    <CPF value={arquivo.assinaturaCpf} />
                                  </p>
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-6">
                                  <b>Momento da assinatura:</b>
                                  <p className="text-dark">
                                    <DateTime value={arquivo.momentoAssinatura} />
                                  </p>
                                </div>
                                <div className="col-6">
                                  <b>Hash SHA-1 da assinatura:</b>
                                  <p className="text-dark">{arquivo.assinaturaHash}</p>
                                </div>
                                <div className="col-12">
                                  <Alert variant="success">
                                    <BsFillFileEarmarkCheckFill />
                                    &nbsp; Assinatura verificada
                                  </Alert>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        {arquivo.assinado && (
                          <div className="form-group row rounded bg-light p-3 py-4">
                            <div className="col-sm-12">
                              <h6 className="font-weight-bold text-primary m-auto">
                                <div className="text-center mb-3">Verificação Pública Utilizando OpenSSL</div>
                              </h6>
                              {!exibirInstrucoes && (
                                <p className="text-center m-auto">
                                  <a
                                    className="btn btn-link btn-block"
                                    href
                                    onClick={() => setExibirInstrucoes((curr) => !curr)}
                                  >
                                    [+] Exibir instruções
                                  </a>
                                </p>
                              )}
                            </div>
                            {exibirInstrucoes && (
                              <>
                                <div className="col-sm-12">
                                  <h6 className="text-primary">Instruções</h6>
                                  <p>
                                    Caso possua uma cópia digital do arquivo assinado, você pode usar uma ferramenta
                                    gratuita, externa e independente para verificar a assinatura digital desse arquivo
                                    chamada&nbsp;
                                    <a href="https://www.openssl.org" target="_blank" rel="noreferrer">
                                      OpenSSL
                                    </a>
                                    .
                                  </p>
                                  <p>
                                    OpenSSL é um projeto de código aberto amplamente utilizado para criar e validar
                                    artefatos de segurança digital.
                                  </p>
                                  <ul className="mt-3">
                                    <li>
                                      <b>Passo 1:</b>
                                      Certifique-se de que você tem instalado corretamente o OpenSSL (v.1.1.1).
                                    </li>
                                    <br />
                                    <SyntaxHighlighter language="powershell" style={docco}>
                                      openssl version
                                    </SyntaxHighlighter>
                                    <li>
                                      <b>Passo 2:</b>
                                      &nbsp;Extraia a chave pública do certificado.
                                    </li>
                                    <br />
                                    <SyntaxHighlighter language="powershell" style={docco}>
                                      {`openssl x509 -pubkey -noout -in "${arquivo.assinaturaNome}.cer" > pubkey.pem`}
                                    </SyntaxHighlighter>
                                    <li>
                                      <b>Passo 3:</b>
                                      Verifique se a assinatura OpenSSL está corretamente associada ao certificado e ao
                                      arquivo.
                                    </li>
                                    <br />
                                    <SyntaxHighlighter language="powershell" style={docco}>
                                      {`openssl dgst -sha256 -verify pubkey.pem -signature "${arquivoNome}.signature" "${arquivoNome}"`}
                                    </SyntaxHighlighter>
                                  </ul>
                                </div>
                                <div className="col-sm-6 mt-3">
                                  <a
                                    href={`${appConfig.hosts.usuarios}v1/arquivo/cert/${(
                                      arquivo.certFingerprint || ""
                                    ).replace(/:/gi, "-")}`}
                                    className="btn btn-primary btn-block"
                                  >
                                    Baixar Certificado
                                  </a>
                                </div>
                                <div className="col-sm-6 mt-3">
                                  <a
                                    href={`${appConfig.hosts.usuarios}v1/arquivo/assinatura/${params.ticket}`}
                                    className="btn btn-primary btn-block"
                                  >
                                    Baixar Assinatura
                                  </a>
                                </div>
                                <p className="text-center m-auto">
                                  <button
                                    type="button"
                                    className="btn btn-link btn-block"
                                    onClick={() => setExibirInstrucoes((curr) => !curr)}
                                  >
                                    [-] Ocultar instruções
                                  </button>
                                </p>
                              </>
                            )}
                          </div>
                        )}
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssinaturaVerificacao;
